export const JSM_CCP_PRODUCT_ID = 'de63a248-1f93-46ed-b6ea-ab8e38af1c88';
export const JPD_CCP_PRODUCT_ID = 'a6f908c8-709c-45f4-9e2d-eca25b93b94a';
export const CONFLUENCE_CCP_PRODUCT_ID = '6aab3f4e-cc71-474d-8d28-abef8b057808';
export const JIRA_CCP_PRODUCT_ID = 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f';
export const CSM_CCP_PRODUCT_ID = 'fbc7e14b-2f9c-45a9-9bcb-3993a4eac0ce';

export const ccpKeyToProductId = {
	[JIRA_CCP_PRODUCT_ID]: 'jira',
	[CONFLUENCE_CCP_PRODUCT_ID]: 'confluence',
	[JSM_CCP_PRODUCT_ID]: 'jsm',
	[JPD_CCP_PRODUCT_ID]: 'jpd',
	[CSM_CCP_PRODUCT_ID]: 'csm',
} as const;

export type CCPKeyToProductIdType = typeof ccpKeyToProductId;
export type CCPKey = keyof CCPKeyToProductIdType;

export const NUM_DISPLAY_RECOMMENDATIONS = 2;
export const NUM_DISPLAY_NEW_PRODUCTS = 4;
